import i18n from '@/libs/i18n'
import useEntityCrud from '@/composable/useEntityCrud'

export default function useFAQCategoryList() {
  function convertResource(resource, selectedLang) {
    return {
      ...resource,
      title: resource.title[selectedLang],
      lang: selectedLang,
      user: resource.userId,
    }
  }

  const MODULE_NAME = 'FAQs-categories'
  const ENDPOINT = 'faq-categories'

  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)

  // Table Handlers
  const tableColumns = [
    { key: 'title', label: i18n.t('general.title'), sortable: true },
    {
      key: 'user', label: i18n.t('general.creator'), type: 'user', sortable: false,
    },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), type: 'dateTime', sortable: true,
    },
    {
      key: 'updatedAt', label: i18n.t('general.updatedAt'), type: 'dateTime', sortable: true,
    },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },
  ]

  return {
    ...entity,
    tableColumns,
    convertResource,
  }
}
